export const styles = {
  mapContainer: {
    width: "100%",
    height: "100%",
    position: "relative",
  },
  fullContainer: {
    width: "100%",
    height: "100%",
  },
  loadingWrapper: {
    padding: "40px",
  },
  mapLoaderOverlay: {
    position: "absolute",
    inset: 0,
    zIndex: 20,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background:
      "linear-gradient(180deg, rgba(232,234,238,0.96) 0%, rgba(232,234,238,0.88) 100%)",
    color: "#183059",
    fontSize: "16px",
    fontWeight: "600",
    letterSpacing: "0.01em",
  },
  stopLabelWrapper: {
    position: "relative",
    top: "-73px",
    left: "0px",
  },
  stopLabel: {
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    color: "#FFFFFF",
    padding: "6px 10px",
    borderRadius: "6px",
    fontSize: "13px",
    fontWeight: "600",
    whiteSpace: "nowrap",
    zIndex: 1000,
    maxWidth: "200px",
    textAlign: "center",
  },
  vehicleMarker: {
    cursor: "pointer",
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  studentImage: {
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    border: "3px solid #20A8E0",
    objectFit: "cover",
    backgroundColor: "white",
    boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
  },
  studentInitial: {
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    border: "3px solid #20A8E0",
    backgroundColor: "#20A8E0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    fontSize: "24px",
    fontWeight: "600",
    boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
  },
  vehicleLabel: {
    height: "22px",
    width: "fit-content",
    borderRadius: "4px",
    padding: "4px 8px",
    backgroundColor: "#20A8E0",
    marginTop: "4px",
    textAlign: "center",
    fontSize: "12px",
    fontWeight: "600",
    color: "#FFFFFF",
    whiteSpace: "nowrap",
    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
  },
  infoWindow: {
    background: "#FFFFFF",
    padding: "16px",
    borderRadius: "12px",
    minWidth: "250px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
  },
  infoWindowTitle: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#1F242E",
    marginBottom: "12px",
    paddingBottom: "8px",
    borderBottom: "1px solid #E8EAEE",
  },
  driverCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    // padding: "8px",
    borderRadius: "8px",
    backgroundColor: "#E8EAEE ",
  },
  driverIcon: {
    width: "40px",
    height: "40px",
  },
  driverName: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#1F242E",
    marginBottom: "2px",
  },
  driverPhone: {
    fontSize: "12px",
    color: "#647490",
  },
  callLink: {
    textDecoration: "none",
  },
  callLinkDisabled: {
    opacity: 0.5,
  },
};
